import { useQuery } from "@tanstack/react-query";
import { IndexerFailures } from "@graylog/server-api";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const INDEXER_FAILURES_COUNT_QUERY_KEY = "indexer_failures_count";
const useIndexerFailuresCount = (since) => {
  const { data, isLoading } = useQuery({
    queryKey: [INDEXER_FAILURES_COUNT_QUERY_KEY, since],
    queryFn: () => defaultOnError(
      IndexerFailures.count(since),
      i18n.t("hooks.failures_count_load_failed", { ns: "indexsets" }),
      i18n.t("hooks.failures_count_load_failed_title", { ns: "indexsets" })
    )
  });
  return {
    data: data == null ? void 0 : data.count,
    isLoading
  };
};
export default useIndexerFailuresCount;
